var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResolvingLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#resolving-left_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1.33,
  d: "M11.816.665h5.46c1.132 0 2.059.927 2.059 2.06v16.367c0 .132-.11.243-.243.243a.245.245 0 0 1-.243-.243v-5.207h-7.033c-.867 0-1.573.706-1.573 1.573 0 1.134-.92 2.06-2.06 2.06H2.726a2.06 2.06 0 0 1-2.06-2.06V6.366c0-1.142.929-2.068 2.06-2.068h5.459c.867 0 1.573-.706 1.573-1.573 0-1.134.92-2.06 2.06-2.06ZM4.793 8.427H1.151v4.963h3.642v3.633h3.39c.868 0 1.574-.706 1.574-1.573v-3.39H6.115V9.757h3.642V4.793H4.793zm7.023-7.276c-.867 0-1.573.707-1.573 1.574v3.39h3.642v2.312h-3.642v4.963h4.964V9.757h3.642V4.793h-3.642V1.151z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "resolving-left_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgResolvingLeft;